// toast
import { toast } from "react-toastify";

export function UseToast(autoClose = 2000, draggable = false) {
    toast.configure({ autoClose, draggable });
}

export function ShowErrorToast(message, position = toast.POSITION.TOP_LEFT) {
    toast.error(message, { position });
}

export function ShowSuccessToast(message, position = toast.POSITION.TOP_LEFT) {
    toast.success(message, { position });
}

export function ShowInfoToast(message, position = toast.POSITION.TOP_LEFT) {
    toast.info(message, { position });
}

export function ShowWarningToast(message, position = toast.POSITION.TOP_LEFT) {
    toast.warn(message, { position });
}
